/* eslint-disable react/button-has-type */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable */

import { RegularButton } from 'pg-ui-library';
import { ModalContainer, ModalContent } from './styles';

interface ConfirmationModalProps {
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

// eslint-disable-next-line react/prop-types
const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ isOpen, message, onConfirm, onCancel }) => (
  <ModalContainer isOpen={isOpen}>
    <ModalContent>
      <p>{message}</p>
      <RegularButton style={{ marginRight: '24%' }} onClick={onCancel}>
        Cancel
      </RegularButton>
      <RegularButton onClick={onConfirm}>Confirm</RegularButton>
    </ModalContent>
  </ModalContainer>
);

export default ConfirmationModal;
